<template>
  <validation-observer ref="form" tag="div">
    <div class="row">
      <validation-provider
          v-slot="{ validated, errors }"
          :name="$t('sales_plans.project_period')"
          class="col-sm-12 col-md-6"
          rules="required"
          vid="period"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('sales_plans.project_period'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="asterisk-after-text"
            label-cols-md="12"
        >
          <datepicker-range
              v-model="model.period"
              :locale-data="periodDateLocaleData"
              :placeholder="$t('sales_plans.placeholders.project_period')"
              :state="errors[0] ? false : (validated ? true : null)"
          />
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="$t('sales_plans.ToP')"
          class="col-sm-12 col-md-6"
          rules="required|min:0"
          vid="term_of_payment"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="`${$t('sales_plans.ToP')} (${$t('units.days')})`"
            :state="errors[0] ? false : (validated ? true : null)"
            class="asterisk-after-text"
            label-cols-md="12"

        >
          <numeral-strict-input
              id="term_of_payment"
              v-model.number="model.term_of_payment"
              :placeholder="lodash.upperFirst($t('sales_plans.ToP'))"
              :state="errors[0] ? false : (validated ? true : null)"
              format="0"
              name="term_of_payment"
          />
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="$t('sales_plans.product')" class="col-md-6"
          rules="required"
          vid="product_id"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.upperFirst($t('sales_plans.product'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="asterisk-after-text"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-products`"
              v-model.number="model.product_id"
              :params="productFetchParams"
              :url="`/products`"
              name="product_id"
          >
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="$t('sales_plans.partner')"
          class="col-md-6"
          rules="required"
          vid="partner_id">
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.upperFirst($t('sales_plans.partner'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="asterisk-after-text"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-partners`"
              v-model.number="model.partner_id"
              :params="{type__like_in: 'partner'}"
              :url="`/customers`"
              name="partner_id"
          >
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="$t('sales_plans.farm')"
          class="col-md-6"
          rules="required"
          vid="farm_id"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.upperFirst($t('sales_plans.farm'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="asterisk-after-text"
            label-cols-md="12"
        >
          <multiselect-ajax
              :key="`${_uid}-farms`"
              v-model.number="model.farm_id"
              :url="`/farms`"
              name="farm_id"
          >
          </multiselect-ajax>
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="$t('sales_plans.processing')"
          class="col-md-6"
          rules="required"
          vid="processing_id"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.upperFirst($t('sales_plans.processing'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="asterisk-after-text"
            label-cols-md="12"
        >
          <processing-select-ajax
              :key="`${_uid}-processings`"
              v-model.number="model.processing_id"
              :params="processingCustomerFetchParams"
              name="processing_id"
              @select="onProcessingCustomerSelect"
              @remove="onProcessingCustomerRemove"
          >
          </processing-select-ajax>
        </b-form-group>
      </validation-provider>
      <div class="col-md-6">
        <b-form-group
            :label="`${lodash.upperFirst($t('sales_plans.limit_amount'))}`"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-input
              id="limit_amount"
              :value="currencyFormatter(this.processingLimitAmount)"
              disabled
              name="limit_amount"
              type="text"
          />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group
            :label="`${lodash.upperFirst($t('sales_plans.used_amount'))}`"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-input
              id="used_amount"
              :value="currencyFormatter(this.processingUsedAmount)"
              disabled
              name="used_amount"
              type="text"
          />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group
            :label="`${lodash.upperFirst($t('sales_plans.available_amount'))}`"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-input
              id="available_amount"
              :value="currencyFormatter(this.processingAvailableAmount)"
              disabled
              name="available_amount"
            type="text"
          />
        </b-form-group>
      </div>
      <validation-provider
          :name="lodash.startCase($t('sales_plans.available_amount'))"
          class="d-none"
          vid="available_amount"
      >
        <input
            :value="processingAvailableAmount"
            name="available_amount"
            type="hidden"
        >
      </validation-provider>
      <div class="col-md-6">
        <b-form-group
            :label="`${lodash.upperFirst($t('sales_plans.dpd_status'))}`"
            class="row mb-3"
            label-cols-md="12"
        >
          <div class="d-flex align-items-center" style="min-height: 36px">
            <b-badge :variant="daysPastDueVariant(processingMaxDaysPastDueIn90Days)" class="d-block"
                     style="padding: 8px 16px">
              {{ formattedDaysPastDue(processingMaxDaysPastDueIn90Days) }}
            </b-badge>
          </div>
        </b-form-group>
      </div>
    </div>
    <b-alert :show="showProcessingDoesntHaveLimitAlert" variant="danger">
      <h5 class="alert-heading">{{ $t('sales_plans.alert_messages.no_limit_header') }}</h5>
      <p class="processing-alert-message text-muted">
        {{ $t('sales_plans.alert_messages.no_limit_message') }}
      </p>
    </b-alert>
    <b-alert :show="showProcessingSummaryErrorAlert" variant="warning">
      <h5 class="alert-heading">{{ $t('sales_plans.alert_messages.summary_fetch_failed_header') }}</h5>
      <p class="processing-alert-message text-muted">
        {{ $t('sales_plans.alert_messages.summary_fetch_failed_message') }}
      </p>
      <b-button
          class="mt-2"
          size="sm"
          variant="outline-warning"
          @click="retryProcessingSummary"
      >
        {{ $t('Retry') }}
      </b-button>
    </b-alert>
    <b-alert :show="showProcessingLimitExceededAlert" variant="danger">
      <h5 class="alert-heading">{{ $t('sales_plans.alert_messages.limit_exceeded_header') }}</h5>
      <p class="processing-alert-message text-muted">
        {{ $t('sales_plans.alert_messages.limit_exceeded_message') }}
      </p>
    </b-alert>
    <hr>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <b-form-group
            :label="lodash.startCase($t('sales_plans.estimated_size'))"
            class="asterisk-after-text"
            label-cols-md="12"
        >
          <div class="d-flex align-items-start">
            <validation-provider
                v-slot="{ validated, errors }"
                :custom-messages="{ lte_field: $t('sales_plans.size_start_greater_than_end_warning', { size: model.estimated_size_end }) }"
                :name="lodash.startCase($t('sales_plans.estimated_size_start'))"
                class="flex-grow-1"
                rules="required|min_value:10|lte_field:@estimated_size_end"
                vid="estimated_size_start"
            >
              <numeral-strict-input
                  id="estimated_size_start"
                  v-model.number="model.estimated_size_start"
                  :placeholder="lodash.upperFirst($t('sales_plans.size_start_placeholder'))"
                  :state="errors[0] ? false : (validated ? true : null)"
                  format="0,0.[00]"
                  name="estimated_size_start"
                  style="text-align: right"
              />
              <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <span class="mx-2 mt-2">-</span>
            <validation-provider
                v-slot="{ validated, errors }"
                :name="lodash.startCase($t('sales_plans.estimated_size_end'))"
                class="flex-grow-1"
                rules="required|min_value:10"
                vid="estimated_size_end"
            >
              <numeral-strict-input
                  id="estimated_size_end"
                  v-model.number="model.estimated_size_end"
                  :placeholder="lodash.upperFirst($t('sales_plans.size_end_placeholder'))"
                  :state="errors[0] ? false : (validated ? true : null)"
                  format="0,0.[00]"
                  name="estimated_size_end"
                  style="text-align: right"
              />
              <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </div>
        </b-form-group>
      </div>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('sales_plans.estimated_quantity'))"
          class="col-sm-12 col-md-6"
          rules="required|min:0"
          vid="estimated_quantity"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('sales_plans.estimated_quantity'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="asterisk-after-text"
            label-cols-md="12"
        >
          <b-input-group>
            <numeral-strict-input
                id="estimated_quantity"
                v-model="model.estimated_quantity"
                :placeholder="lodash.upperFirst($t('sales_plans.estimated_quantity'))"
                :state="errors[0] ? false : validated ? true : null"
                format="0,0.[000]"
                name="estimated_quantity"
                style="text-align: right"
            />
          </b-input-group>
        </b-form-group>
      </validation-provider>
      <validation-provider
          ref="estimatedSaleProvider"
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('sales_plans.estimated_sale'))"
          class="col-sm-12 col-md-6"
          :rules="estimatedSaleRules"
          vid="estimated_sale"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('sales_plans.estimated_sale'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="asterisk-after-text"
            label-cols-md="12"
        >

          <numeral-strict-input
              id="estimated_sale"
              v-model="model.estimated_sale"
              :placeholder="lodash.upperFirst($t('sales_plans.estimated_sale'))"
              :state="errors[0] ? false : (validated ? true : null)"
              format="$ 0,0.[00]"
              name="estimated_sale"
              style="text-align: right"
          />
        </b-form-group>
      </validation-provider>
      <validation-provider
          v-slot="{ validated, errors }"
          :name="lodash.startCase($t('sales_plans.estimated_margin'))"
          class="col-sm-12 col-md-6"
          rules="required|min:0|lte_field:@estimated_sale"
          vid="estimated_margin"
      >
        <b-form-group
            :invalid-feedback="errors[0]"
            :label="lodash.startCase($t('sales_plans.estimated_margin'))"
            :state="errors[0] ? false : (validated ? true : null)"
            class="asterisk-after-text"
            label-cols-md="12"
        >
          <numeral-strict-input
              id="estimated_margin"
              v-model.number="model.estimated_margin"
              :placeholder="lodash.upperFirst($t('sales_plans.estimated_margin'))"
              :state="errors[0] ? false : (validated ? true : null)"
              format="$ 0,0.[00]"
              name="estimated_margin"
              style="text-align: right"
          />
        </b-form-group>
      </validation-provider>
      <div class="col-md-6">
        <b-form-group
            :label="`${lodash.upperFirst($t('sales_plans.estimated_margin'))} (%)`"
            class="row mb-3"
            label-cols-md="12"
        >
          <b-form-input
              id="margin_percentage"
              :value="percentageFormatter(this.estimatedMarginRatio)"
              disabled
              name="margin_percentage"
              style="text-align: right"
              type="text"
          />
        </b-form-group>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import DatepickerRange from '@/components/inputs/filter/datepicker-range'
import FormModel from './model';
import ProcessingSelectAjax from '@/components/inputs/processing-select-ajax'
import NumeralStrictInput from '@/components/inputs/numeral-strict';
import {daysPastDueVariant} from "@/helpers/ui/badgeVariants";
import {currencyFormatter, percentageFormatter} from "@/helpers/ui/formatters";

export default {
  extends: FormModel,
  components: {
    DatepickerRange,
    ProcessingSelectAjax,
    NumeralStrictInput,
  },
  created() {
    if (this.model.processing) {
      this.$set(this.model, 'processing', this.model.processing);
    }

    if (this.model.processing_id) {
      this.processingSummaryResolved = false;
      this.fetchProcessingSummary(this.model.processing_id);
      return;
    }

    this.processingSummaryResolved = true;
  },
  mounted() {
    this.$watch(() => {
      const observer = this.$refs.form;
      return !observer || observer.flags.invalid || observer.flags.pending;
    }, (blocked) => {
      this.formValidationBlocked = blocked;
    }, {immediate: true});
  },
  data() {
    return {
      model: {
        ...this.value,
        period: Array.isArray(this.value?.period) ? this.value.period : [],
        processing: this.value?.processing ? this.value.processing : {},
      },
      processingSummaryResolved: true,
      processingSummaryRequestId: 0,
      processingSummaryError: false,
      enforceEstimatedSaleLimit: true,
      formValidationBlocked: true,
    }
  },
  computed: {
    periodDateLocaleData() {
      const locale = this.$i18n?.locale || 'en'
      const localeData = this.$moment.localeData(locale) || this.$moment.localeData()

      return {
        direction: 'ltr',
        format: 'dd mmmm yyyy',
        separator: ' - ',
        applyLabel: this.$t('Apply'),
        cancelLabel: this.$t('Cancel'),
        resetLabel: this.$t('Reset'),
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: localeData.weekdaysMin(),
        monthNames: localeData.months(),
        firstDay: localeData.firstDayOfWeek(),
      }
    },
    isEstimatedSaleLessThanEqualAvailableLimit() {
      return this.model.estimated_sale <= this.processingAvailableAmount;
    },
    isProcessingHasLimit() {
      return this.processingLimitAmount !== null && this.processingLimitAmount > 0;
    },
    isProcessingHasAvailableLimit() {
      return this.processingAvailableAmount !== null && this.processingAvailableAmount > 0;
    },
    showProcessingDoesntHaveLimitAlert() {
      return this.isProcessingSummaryReady && !this.isProcessingHasLimit;
    },
    showProcessingLimitExceededAlert() {
      return this.isProcessingSummaryReady
          && this.isProcessingHasLimit
          && !this.isProcessingHasAvailableLimit;
    },
    showProcessingSummaryErrorAlert() {
      return this.processingSummaryResolved && this.processingSummaryError && !!this.model.processing_id;
    },
    isProcessingSummaryReady() {
      return this.processingSummaryResolved && !this.processingSummaryError && !!this.model.processing_id;
    },
    processingMaxDaysPastDueIn90Days() {
      return this.model.processing?.odoo_res_partner?.max_days_past_due_in_90_days
          ?? this.model.processing?.max_days_past_due_in_90_days;
    },
    processingCustomerFetchParams() {
      return {
        sort: 'code',
      }
    },
    productFetchParams() {
      return {
        sort: 'name',
        code: 'cash,deposit_goods,harvest',
      }
    },
    processingLimitGroup() {
      return this.model.processing?.limit_summary
          ?? this.model.processing?.odoo_res_partner?.odoo_obligor_limit?.odoo_obligor_limit_group
          ?? null;
    },
    processingLimitAmount() {
      if (!this.processingSummaryResolved || this.processingSummaryError || !this.processingLimitGroup) {
        return null;
      }

      return this.normalizeNumber(this.processingLimitGroup?.limit_amount);
    },
    processingAvailableAmount() {
      if (!this.processingSummaryResolved || this.processingSummaryError || !this.processingLimitGroup) {
        return null;
      }

      const group = this.processingLimitGroup;
      const remaining = this.normalizeNumber(
          group?.remaining_amount_adjusted
          ?? group?.available_amount
      );

      if (remaining !== null) {
        return remaining;
      }

      const limit = this.normalizeNumber(group?.limit_amount);
      const used = this.normalizeNumber(
          group?.used_amount_adjusted
          ?? group?.used_amount
      );

      if (limit === null) {
        return null;
      }

      if (used === null) {
        return 0;
      }

      return limit - used;
    },
    processingUsedAmount() {
      if (!this.processingSummaryResolved || this.processingSummaryError || !this.processingLimitGroup) {
        return null;
      }

      return this.normalizeNumber(
          this.processingLimitGroup?.used_amount_adjusted
          ?? this.processingLimitGroup?.used_amount
      );
    },
    estimatedMarginRatio() {
      return this.model?.estimated_margin_ratio ?? (this.model.estimated_sale ? this.model.estimated_margin / this.model.estimated_sale : 0)
    },
    estimatedSaleRules() {
      const rules = {
        required: true,
        min: 0,
      };

      if (this.enforceEstimatedSaleLimit) {
        rules.lte_field = '@available_amount';
      }

      return rules;
    },
    isPublishDisabled() {
      return !(
          !this.formValidationBlocked
          && this.processingSummaryResolved
          && !this.processingSummaryError
          && this.isProcessingHasLimit
          && this.isProcessingHasAvailableLimit
          && this.isEstimatedSaleLessThanEqualAvailableLimit
      );
    }
  },
  watch: {
    isPublishDisabled: {
      immediate: true,
      handler(value) {
        this.$emit('update:publish-disabled', value);
      }
    }
  },
  methods: {
    daysPastDueVariant,
    formattedDaysPastDue(days_past_due) {
      return days_past_due ?? '-'
    },
    currencyFormatter,
    normalizeNumber(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      const number = Number(value);
      return Number.isFinite(number) ? number : null;
    },
    resetProcessingSummary() {
      this.processingSummaryRequestId += 1;
      this.$set(this.model, 'processing', {});
      this.processingSummaryResolved = true;
      this.processingSummaryError = false;
      this.validateEstimatedSale();
    },
    async validateAll(validationOptions = {}) {
      const {skipEstimatedSaleLimit = false} = validationOptions;

      if (!skipEstimatedSaleLimit) {
        return FormModel.methods.validateAll.call(this);
      }

      const previousEnforcement = this.enforceEstimatedSaleLimit;
      this.enforceEstimatedSaleLimit = false;

      try {
        await this.$nextTick();
        return await FormModel.methods.validateAll.call(this);
      } finally {
        this.enforceEstimatedSaleLimit = previousEnforcement;
      }
    },
    onProcessingCustomerSelect(value) {
      if (!value || !value.id) {
        this.resetProcessingSummary();
        return;
      }

      this.processingSummaryResolved = false;
      this.processingSummaryError = false;
      this.$set(this.model, 'processing', value);
      this.fetchProcessingSummary(value.id);
    },
    onProcessingCustomerRemove() {
      this.resetProcessingSummary();
    },
    retryProcessingSummary() {
      if (!this.model.processing_id) {
        return;
      }

      this.processingSummaryResolved = false;
      this.processingSummaryError = false;
      this.fetchProcessingSummary(this.model.processing_id);
    },
    validateEstimatedSale() {
      this.$nextTick(() => {
        this.$refs.estimatedSaleProvider?.validate?.();
      });
    },
    processingCustomerLabel(value) {
      let {code, name} = value
      return `${code} - ${name}`
    },
    fetchProcessingSummary(id) {
      const requestId = ++this.processingSummaryRequestId;

      return this.$axios.get(`/v1/processing-customers/${id}`)
          .then(({data}) => {
            if (requestId !== this.processingSummaryRequestId) {
              return null;
            }

            const payload = data?.data ?? {};
            this.$set(this.model, 'processing', payload);
            this.validateEstimatedSale();
          })
          .catch(() => {
            if (requestId !== this.processingSummaryRequestId) {
              return null;
            }

            this.processingSummaryError = true;
            this.$set(this.model, 'processing', {});
            this.validateEstimatedSale();
            return null;
          })
          .finally(() => {
            if (requestId !== this.processingSummaryRequestId) {
              return;
            }

            this.processingSummaryResolved = true;
          });
    },
    percentageFormatter,
  }
}
</script>

<style lang="scss" scoped>
@import "../../design/custom/components/status-badge";
@import "../../design/custom/components/required-field-asterisk";
@import "../../design/custom/components/sales-plan-label";

::v-deep {
  .col-form-label {
    @include sales-plan-label;
  }

  .alert-heading {
    color: #DC2626 !important;
  }

  .processing-alert-message {
    font: 400 14px/20px Inter;

    &.text-muted {
      color: #667085 !important;
      margin: 0;
    }
  }

}
</style>
